import {
  navbarHeightRem,
  verticalPageContentPaddingHeightRem,
  paginationHeightRem,
} from 'config/material-ui/dimensions';

interface GetTableHeightProps {
  itemsLength: number;
  isPaginationDisplayed: boolean;
}

export default function getTableHeight({
  itemsLength,
  isPaginationDisplayed,
}: GetTableHeightProps) {
  if (!itemsLength) {
    return 'auto';
  }

  if (isPaginationDisplayed) {
    return `calc(100vh - ${
      paginationHeightRem + navbarHeightRem + verticalPageContentPaddingHeightRem
    }rem)`;
  }

  return `calc(100vh - ${navbarHeightRem + verticalPageContentPaddingHeightRem}rem)`;
}
